import React, { useState, useEffect } from "react";
import NewsCard from "./NewsCard";
import newsData from "../../data/news.json";
import { URL, URL_SERVER } from "@/constants";
import axios from "axios";
import LazyLoadComponent from "../Common/LazyLoadComponent";
import Pagination from "../Common/Pagination";
import ErrorPage from "@/pages/_error";

// export async function getServerSideProps() {
//   axios.defaults.headers.post["Content-Type"] = "application/json";
//   axios.defaults.baseURL = URL_SERVER;

//   try {
//     const input = {
//       attributes: ["id"],
//       limit: 5,
//       offset: 0,
//     };
//     const response = await axios.post(URL.FIND_ALL_NEW, input);
//     let data = [];
//     if (response.status === 200) {
//       if (response.data.data) {
//         data = response.data.data?.rows.map((item) => item.id);
//       }
//     }
//     return { props: { newsIds: data }, revalidate: 60 };
//   } catch (error) {
//     return { props: { error: { statusCode: response.status } } };
//   }
// }

const News = () => {
  const [whereClause, setWhereClause] = useState({
    attributes: ["id"],
    limit: 5,
    offset: 0,
  });
  const [itemsIds, setItemsIds] = useState([]);
  const [totalRecord, setTotalRecord] = useState(0);

  useEffect(() => {
    getNewsData(whereClause);
  }, [whereClause]);

  const getNewsData = async (input) => {
    axios.defaults.headers.post["Content-Type"] = "application/json";
    axios.defaults.baseURL = URL_SERVER;
    try {
      const response = await axios.post(URL.FIND_ALL_NEW, input);
      if (response.status === 200) {
        if (response.data.data) {
          setTotalRecord(response.data.data?.count);
          setItemsIds(response.data.data?.rows.map((item) => item.id));
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const NewsContent = ({ id, index }) => {
    const [data, setData] = useState([]);
    useEffect(() => {
      getNewsById();
    }, []);

    const getNewsById = async () => {
      const response = await axios.post(URL.FIND_ALL_NEW, {
        where: { id: id },
      });
      if (response.status === 200) {
        if (response.data.data) {
          setData(response.data.data?.rows[0]);
        }
      }
    };

    return (
      <NewsCard
        key={index}
        id={data.id}
        title={data.title}
        index={index}
        link={data.link ? data.link : "/news"}
        news={data.abstract}
        image={data.img}
      />
    );
    // : (
    //   <ErrorPage />
    // );
  };

  return (
    <>
      <div className="container news-wrapper">
        {itemsIds &&
          itemsIds.map((data, index) => (
            <LazyLoadComponent key={index}>
              <NewsContent id={data} index={index} />
            </LazyLoadComponent>
          ))}
        <Pagination
          whereClause={whereClause}
          setWhereClause={setWhereClause}
          totalRecord={totalRecord}
        />
      </div>
    </>
  );
};

export default News;
